module.exports = __webpack_public_path__ + "img/ic-lineplot-plus.125ef458.svg";